var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    id: "social-tiktok",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.016 1.616c.18 2.023 1.362 4.045 3.034 5.197 1.021.7 2.753 1.291 3.795 1.291h.35v5.136l-1.021-.06c-2.023-.13-4.115-.82-5.847-1.922l-.51-.33-.071 5.617c-.05 4.475-.1 5.757-.22 6.367-.731 3.545-3.615 6.428-7.169 7.159-.991.21-2.773.21-3.765 0-3.564-.73-6.438-3.604-7.168-7.169-.21-.99-.21-2.773 0-3.754.61-2.954 2.733-5.507 5.546-6.668 1.112-.461 1.783-.591 3.284-.641l1.422-.06v5.036l-.47-.06c-.27-.03-.531-.07-.601-.09-.29-.09-1.442.18-2.103.5-1.682.821-2.663 2.734-2.343 4.556.17.941.511 1.612 1.172 2.303 1.672 1.752 4.295 1.832 6.097.18.681-.62 1.222-1.652 1.352-2.583.06-.37.1-5.006.1-10.693V.895h5.076l.06.721z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.3edcd1e6f4cbca0b3347ee80b08bfe80.svg";
export { ForwardRef as ReactComponent };